<template>
  <Card>
    <template v-slot:content>
      <div class="p-grid p-jc-between">
        <div class="p-col-4">
          <a
            href="https://docs.google.com/document/d/1NlWNfwNYmQfxFUn7VwU4YPqJ7mjm9f7q68GdmsbniyU/edit?usp=sharing"
            target="_blank"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="link-icon"
            >
              <path
                d="M18.0405 4.5C16.0303 4.5 13.8654 4.9 12.3707 6C10.8759 4.9 8.711 4.5 6.70077 4.5C4.69054 4.5 2.52567 4.9 1.03088 6V20.65C1.03088 21.3 1.78343 21.1 1.80405 21.1C3.19575 20.45 5.20598 20 6.70077 20C8.711 20 10.8759 20.4 12.3707 21.5C13.7624 20.65 16.288 20 18.0405 20C19.7415 20 21.494 20.3 22.9373 21.05C23.3599 21.26 23.7104 20.86 23.7104 20.6V6C22.1744 4.88 19.9683 4.5 18.0405 4.5ZM21.6486 18.5C20.5147 18.15 19.2776 18 18.0405 18C16.288 18 13.7624 18.65 12.3707 19.5V8C13.7624 7.15 16.288 6.5 18.0405 6.5C19.2776 6.5 20.5147 6.65 21.6486 7V18.5Z"
                fill="#396DF4"
              />
            </svg>
            Guia de uso
          </a>
        </div>
        <div class="p-col-4">
          <a
            href="https://youtube.com/playlist?list=PLDBquHXPuwa1F_YajONpq2BHrQzXvRGn6"
            target="_blank"
          >
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="link-icon"
            >
              <path
                d="M4.12354 6H2.06177V20C2.06177 21.1 2.98957 22 4.12354 22H18.556V20H4.12354V6ZM20.6178 2H8.2471C7.11312 2 6.18532 2.9 6.18532 4V16C6.18532 17.1 7.11312 18 8.2471 18H20.6178C21.7517 18 22.6795 17.1 22.6795 16V4C22.6795 2.9 21.7517 2 20.6178 2ZM12.3706 14.5V5.5L18.556 10L12.3706 14.5Z"
                fill="#E80000"
              />
            </svg>
            Vídeos Tutoriais
          </a>
        </div>
        <div class="p-col-4">
          <a href="https://wa.me/message/FHASR6QCYFKCJ1" target="_blank">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="link-icon"
            >
              <path
                d="M10.4083 0.228333C8.48004 0.401472 6.85116 0.966871 5.30258 1.99647C2.6738 3.74745 0.952301 6.58303 0.619 9.70571C0.56422 10.2375 0.564221 11.4442 0.623181 11.9673C0.754081 13.1868 1.11686 14.419 1.67808 15.554L1.9566 16.1236L1.06626 18.7946C0.20958 21.3686 0.1801 21.474 0.23906 21.5837C0.27712 21.6471 0.35302 21.7272 0.41638 21.7611C0.51758 21.82 0.703261 21.778 3.43764 21.0606L6.34912 20.2926L6.82586 20.5077C9.14246 21.5415 11.7796 21.7188 14.206 21.0014C17.0035 20.1744 19.4257 18.1236 20.7041 15.499C21.202 14.4821 21.4974 13.5368 21.6787 12.3976C21.7927 11.7055 21.8138 10.1822 21.7251 9.52839C21.4424 7.52419 20.6661 5.69709 19.4466 4.16941C17.7882 2.09767 15.3282 0.700891 12.6235 0.304232C12.2101 0.245272 10.7839 0.194672 10.4083 0.228333ZM7.8218 3.91641C8.10032 4.03873 8.33242 4.21605 8.68684 4.57465C9.09186 4.98825 9.3156 5.27513 9.74174 5.92083C10.1131 6.48623 10.2143 6.75639 10.189 7.11917C10.1637 7.48217 10.0581 7.63397 9.5433 8.06847C9.1594 8.38923 9.0538 8.50319 8.94402 8.72253C8.7711 9.04747 8.76252 9.26263 8.91036 9.55391C9.05798 9.84937 12.2016 12.9888 12.4759 13.1111C12.9273 13.3179 13.3493 13.1492 13.8346 12.5752C14.4128 11.8875 14.5309 11.8072 14.9696 11.8072C15.2818 11.8072 15.5519 11.9128 16.0414 12.2333C16.6955 12.6594 17.1216 13.0013 17.552 13.4486C18.0287 13.9464 18.1891 14.2588 18.1891 14.6975C18.1891 15.1575 18.0626 15.3894 17.4844 15.9762C16.8979 16.571 16.4506 16.9171 15.957 17.1492C15.4169 17.4024 15.0836 17.4741 14.5012 17.4741C13.4421 17.4658 12.4295 17.0269 11.1889 16.0353C10.8472 15.7608 6.96512 11.9167 6.36606 11.2585C5.46736 10.2711 4.87226 9.28375 4.64456 8.41035C4.50112 7.85749 4.49254 7.14029 4.61926 6.65497C4.73322 6.23301 4.98226 5.73933 5.29862 5.32573C5.62356 4.89541 6.45472 4.08097 6.68682 3.96283C7.0496 3.77715 7.46738 3.76439 7.8218 3.91641Z"
                fill="#00A42E"
              />
            </svg>
            Enviar Mensagem
          </a>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
export default {
  name: 'HelpLinks',
};
</script>

<style scoped>
div >>> .p-card-content {
  padding: 0 !important;
}

.link-icon {
  margin-bottom: -5px;
  padding-right: 3px;
}

a {
  font-size: 0.9rem;
}
</style>
